import { motion } from 'motion/react';
import React from 'react';
import styled from 'styled-components';
import { Absolute } from '../Absolute/Absolute';
import { Box } from '../Box/Box';
import { Flex } from '../Flex/Flex';
import { IconButton } from '../IconButton/IconButton';
import { theme } from '../theme';
import { getPaletteColor } from '../utils';
const Component = React.forwardRef((props, ref) => React.createElement(Box, {
  ...props,
  ref: ref
}));
const AnimatedComponent = motion.create(Component);
const getBorderRadiusStyles = (placement, isFloating) => {
  const themeRadius = theme.borderRadii['2xl'];
  if (isFloating) {
    return themeRadius;
  }
  switch (placement) {
    case 'top':
      return `0px 0px ${themeRadius} ${themeRadius}`;
    case 'right':
      return `${themeRadius} 0px 0px  ${themeRadius}`;
    case 'bottom':
      return `${themeRadius} ${themeRadius} 0px 0px`;
    case 'left':
      return `0px ${themeRadius} ${themeRadius} 0px`;
  }
};
const positions = {
  top: `top:0; left:0; right:0;`,
  right: `right: 0; bottom:0;`,
  bottom: `bottom:0; left:0; right:0;`,
  left: `left:0;bottom:0;`
};
const getPlacementStyles = placement => placement ? `margin-inline:auto; margin-block:auto; ${positions[placement]};` : ``;
export const DrawerWrapper = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Drawerstyled__DrawerWrapper",
  componentId: "sc-19fw04m-0"
})(["", ""], ({
  placement,
  zIndex,
  position
}) => `
    position: ${position || 'absolute'};
    ${getPlacementStyles(placement)}
    ${getPlacementStyles(placement)}
    z-index: ${zIndex || theme.zIndices.modal};
    `);
export const DrawerRoot = /*#__PURE__*/styled(AnimatedComponent).withConfig({
  displayName: "Drawerstyled__DrawerRoot",
  componentId: "sc-19fw04m-1"
})(["background-color:", ";", ""], getPaletteColor('background.lightest'), ({
  theme,
  placement,
  isFloating
}) => `box-shadow: ${theme.shadows['overlay-md']};
    border-radius: ${getBorderRadiusStyles(placement, isFloating)};
    `);
export const HeadingWrapper = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "Drawerstyled__HeadingWrapper",
  componentId: "sc-19fw04m-2"
})([""]);
export const HeaderButton = /*#__PURE__*/styled(IconButton).withConfig({
  displayName: "Drawerstyled__HeaderButton",
  componentId: "sc-19fw04m-3"
})(["background-color:", ";color:", ";padding:0;&:hover{background-color:", ";color:", ";}"], getPaletteColor('background.lightest'), getPaletteColor('text.dark'), getPaletteColor('background.light'), getPaletteColor('text.dark'));
/**
 * Data below is used for Drawer.stories.tsx
 */
export const Handle = /*#__PURE__*/styled.div.withConfig({
  displayName: "Drawerstyled__Handle",
  componentId: "sc-19fw04m-4"
})(["display:flex;flex-direction:row;align-items:flex-start;gap:8px;width:48px;height:8px;background:#d5dce4;box-shadow:inset 0px 2px 2px rgba(0,0,0,0.08);border-radius:999px;flex:none;order:0;flex-grow:0;z-index:0;"]);
export const HandleContainer = /*#__PURE__*/styled(Absolute).withConfig({
  displayName: "Drawerstyled__HandleContainer",
  componentId: "sc-19fw04m-5"
})(["transform:translateX(-50%);cursor:grab;left:50%;"]);
export const DrawerHandle = () => React.createElement(HandleContainer, null, React.createElement(Handle, null));